import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";
import { disabledContainedButtonStyles } from "./buttonStyles";

const muiTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
      dark: colors.primaryHover,
      light: colors.primaryLight,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.secondary,
    },
    error: {
      main: colors.link,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          ...disabledContainedButtonStyles,
        },
        containedPrimary: {
          backgroundColor: colors.primary,
          "&:hover": {
            backgroundColor: colors.primaryHover,
          },
          ...disabledContainedButtonStyles,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: colors.link,
        },
      },
    },
  },
});

export default muiTheme;
